"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Component {
    __TYPE__;
}
exports.default = Component;
